// Reading.tsx

import React from 'react';
import './Reading.css';
import atomicHabits from '../images/atomic_habits.jpg';
import richDadPoorDad from '../images/rich_dad_poor_dad.jpg';
import alchemist from '../images/alchemist.jpg';
import eatThatFrog from '../images/eat_that_frog.jpg';
import BlueOceanStrategy from '../images/BlueOceanStrategy.jpg';
import ThinkAndGrowRich from '../images/ThinkAndGrowRich.png';
import TheLeanStartup from '../images/TheLeanStartup.jpg';
import Narconomics from '../images/Narconomics.jpg';
import TheRichestManInBabylon from '../images/TheRichestManInBabylon.jpg';
import Titan from '../images/Titan.jpg';
import HowToOwnYourOwnMind from '../images/HowToOwnYourOwnMind.jpg';
import QuantumNetworking from '../images/QuantumNetworking.jpg';

const books = [
  {
    title: "Blue Ocean Strategy",
    author: "W. Chan Kim and Renee Mauborgne",
    imgSrc: BlueOceanStrategy,
    description: "A groundbreaking guide to creating uncontested market space and achieving rapid growth.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Quantum Networking",
    author: "Sam Rossi and Andra Pickens",
    imgSrc: QuantumNetworking,
    description: "Play the long game. Build a network that lasts a lifetime.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Think and Grow Rich",
    author: "Napoleon Hill",
    imgSrc: ThinkAndGrowRich,
    description: "A timeless guide to achieving financial success and personal fulfillment.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "The Lean Startup",
    author: "Eric Ries",
    imgSrc: TheLeanStartup,
    description: "A guide to building successful startups through continuous innovation.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "The Richest Man in Babylon",
    author: "George S. Clason",
    imgSrc: TheRichestManInBabylon,
    description: "A classic book of personal finance, using parables set in ancient Babylon to teach timeless principles and practical advice.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Atomic Habits",
    author: "James Clear",
    imgSrc: atomicHabits,
    description: "A practical guide to building good habits and breaking bad ones.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Narconomics",
    author: "Tom Wainwright",
    imgSrc: Narconomics,
    description: "A fascinating exploration of the drug trade and its impact on society.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Titan",
    author: "Ron Chernow",
    imgSrc: Titan,
    description: "A biography of the titan of industry, John D. Rockefeller.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "How to Own Your Own Mind",
    author: "Napoleon Hill",
    imgSrc: HowToOwnYourOwnMind,
    description: "Knowledge is not power. Only applied knowledge is power. This book teaches you how to use what you know, and how to know what’s worth knowing.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Rich Dad Poor Dad",
    author: "Robert Kiyosaki",
    imgSrc: richDadPoorDad,
    description: "An eye-opener on wealth, assets, and financial literacy.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "The Alchemist",
    author: "Paulo Coelho",
    imgSrc: alchemist,
    description: "A magical journey of following one's dreams.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  {
    title: "Eat That Frog",
    author: "Brian Tracy",
    imgSrc: eatThatFrog,
    description: "A motivational book on overcoming procrastination.",
    amazonLink: "https://amzn.to/4kHPOtz"
  },
  

];

const Reading: React.FC = () => {
  return (
    <div className="reading-container">
      <h2 className="reading-title">📚 Books That Shaped My Journey</h2>
      <p className="reading-intro">These books have influenced my perspectives, motivation, and self-growth.</p>
      <div className="books-grid">
        {books.map((book, index) => (
          <a 
            key={index} 
            href={book.amazonLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="book-card" 
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
          >
            <img src={book.imgSrc} alt={book.title} className="book-cover" />
            <div className="book-info">
              <h3 className="book-title">{book.title}</h3>
              <h4 className="book-author">{book.author}</h4>
              <p className="book-description">{book.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Reading;
